
import { Dropdown, Option } from '@src/components/Dropdown';
import PageSlugs from '@src/components/layout/pageSlugs';
import { Link } from 'gatsby';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'theme-ui';
const subjectsDropdown = ({ placeholder, subjectsView }) => {
  const { t, i18n } = useTranslation();
  const locale = i18n.language;
  return (
    <Box sx={{ maxWidth: '650px' }} className="home-page__subject-list">
      <Dropdown placeholder={placeholder}>
        {subjectsView.map(({ name, slug, count }) => (
          <Option key={name}>
            <Link
              sx={{
                display: 'inline-block',
                color: 'text',
                fontSize: 3,
                transition: '200ms ease-in-out',
                '&:hover': {
                  color: 'label',
                },
              }}
              to={`/${slug}/${PageSlugs.subjectsSearch[locale]}`}
            >
              {name}{' '}
              <span sx={{ color: 'label', marginLeft: '6px' }}>
                {count && `(${count})`}
              </span>
            </Link>
          </Option>
        ))}
      </Dropdown>
    </Box>
  );
};

export default subjectsDropdown;
